module.exports = __webpack_public_path__ + "img/tubiao-42.924f5a52.png";